<div class="row mt-5 mb-4">
  <div class="col-12 col-lg-12">
    <app-card-container>
      <div class="row mb-3">
        <div class="col-12">
          <div class="header-text">Exclusions</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 sub-text">
          <p *ngFor="let exclusion of exclusions; let i = index">
            {{exclusion}}
            <br *ngIf="i < exclusions.length - 1">
          </p>
        </div>
      </div>
    </app-card-container>
  </div>
</div>